import Component from '../core/Component'

export default class CourseMain extends Component {
    prepare() {
        setTimeout(() => {
            this.element.classList.add('is-ready')
        }, 0)
    }
}